import React from 'react';
import {Button} from 'antd';
import {ReactComponent as NewQueryIcon} from './icons/NewQuery.svg';
import styles from '../../components/common/styled/Buttons.module.scss';

interface NewQueryButtonProps {
    onClick: () => void
}

const NewQueryButton = ({onClick}: NewQueryButtonProps) => {
    return (
        <Button onClick={onClick} className={styles.queryBuilderButton}>
            <NewQueryIcon className={styles.newQueryButtonIcon}/>
            New Query
        </Button>
    );
};

export default NewQueryButton;